import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Download, Share2, FileText, ExternalLink } from "lucide-react";
import { api, API_BASE } from "../lib/api";
import Sidebar from "../components/Sidebar";

export default function Certificates() {
  const [certs, setCerts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/me/certificates")
      .then(r => setCerts(r.data.certificates || []))
      .catch(e => console.error(e))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-fc-navy text-white flex" data-testid="certificates-page">
      <Sidebar />
      <main className="flex-1 min-w-0">
        <div className="h-20 px-6 lg:px-10 flex items-center justify-between border-b border-white/10 bg-[#060A24]/70 backdrop-blur sticky top-0 z-30">
          <div>
            <p className="fc-overline text-[10px]">CERTIFICATES</p>
            <h1 className="text-lg sm:text-xl font-black tracking-tight">Your verified completions</h1>
          </div>
        </div>

        <div className="px-6 lg:px-10 py-8">
          {loading ? (
            <p className="text-white/50">Loading…</p>
          ) : certs.length === 0 ? (
            <div className="bg-[#060A24] border border-white/10 p-10 text-center">
              <FileText className="mx-auto text-fc-red mb-4" size={32} />
              <p className="text-white/70 mb-3">No certificates yet. Complete a course to earn your first one.</p>
              <Link to="/courses" className="btn-fc-red">Browse Courses</Link>
            </div>
          ) : (
            <div className="grid gap-5" style={{ gridTemplateColumns: "repeat(auto-fill, minmax(360px, 1fr))" }}>
              {certs.map((c) => {
                const shareCardUrl = `${API_BASE}/certificates/share-card/${c.id}`;
                const verifyUrl = `${window.location.origin}/verify/${c.id}`;
                const sharePageUrl = `${window.location.origin}/share/cert/${c.id}`;
                const downloadPdf = async () => {
                  try {
                    const { downloadFromApi } = await import("../lib/downloads");
                    await downloadFromApi(`/certificates/${c.id}/pdf`, `Freddy-Compute-Academy-${c.course_slug || c.id.slice(0,8)}.pdf`);
                  } catch (e) {
                    console.error("pdf download", e);
                  }
                };
                return (
                  <div key={c.id} className="bg-[#060A24] border border-white/10 overflow-hidden" data-testid={`cert-card-${c.id}`}>
                    <div className="relative aspect-[2/1] bg-fc-navy">
                      <img src={shareCardUrl} alt={c.course_title} className="absolute inset-0 w-full h-full object-cover" />
                    </div>
                    <div className="p-5">
                      <p className="fc-overline mb-2 text-[10px]">CERTIFICATE OF COMPLETION</p>
                      <h3 className="font-black text-lg leading-tight tracking-tight mb-2">{c.course_title}</h3>
                      <p className="text-white/55 text-xs mb-4">
                        Earned {c.earned_at ? new Date(c.earned_at).toLocaleDateString() : ""} · ID {c.id.slice(0, 8)}
                      </p>
                      <div className="flex flex-wrap gap-2">
                        <button onClick={downloadPdf} className="btn-fc-red text-xs py-2 px-3" data-testid={`cert-download-${c.id}`}>
                          <Download size={12} /> PDF
                        </button>
                        <a href={sharePageUrl} target="_blank" rel="noopener noreferrer" className="btn-fc-outline text-xs py-2 px-3" data-testid={`cert-share-${c.id}`}>
                          <ExternalLink size={12} /> Share page
                        </a>
                        <a href={verifyUrl} target="_blank" rel="noopener noreferrer" className="btn-fc-outline text-xs py-2 px-3">
                          <ExternalLink size={12} /> Verify
                        </a>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
